import React from 'react';
import { Section } from './ui/Section';
export function InstructorTestimonials() {
  const testimonials = [{
    quote: 'Subí mis precios un 40% y no perdí ni una alumna',
    text: 'El Tomo 1 me cambió la forma de ver mi negocio. Entendí que no cobro por bailar. Cobro por transformar la semana de mis alumnas.',
    author: 'Sofía R.',
    location: 'Barcelona'
  }, {
    quote: 'Por fin dejé de llegar a clase sin saber qué dar',
    text: 'Ahora tengo un mes entero planificado en una tarde. Mis alumnas dicen que las clases fluyen diferente.',
    author: 'Marta L.',
    location: 'Madrid'
  }, {
    quote: 'Mi retención pasó del 68% al 87% en dos meses',
    text: 'El sistema de retención me dio el diagnóstico exacto. Solo por eso ya se ha pagado cien veces.',
    author: 'Carmen V.',
    location: 'Sevilla'
  }, {
    quote: 'Material práctico y listo para usar el mismo día',
    text: 'Son fichas, scripts y estructuras que saqué en clase la misma semana que lo descargué.',
    author: 'Laura M.',
    location: 'Valencia'
  }];
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section className="bg-white/50" data-id="element-172">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title font-display" data-id="element-173">
        ⭐ LO QUE DICEN LAS QUE YA LO TIENEN
      </h2>
      <p className="text-center text-brand-textMuted mb-12 text-sm tracking-wide font-body" data-id="element-174">
        (Testimonios reales de la comunidad)
      </p>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-12" data-id="element-175">
        {testimonials.map((testimonial, i) => <div key={i} className="bg-brand-cardPink border border-brand-border rounded-2xl p-6 shadow-card relative" style={{
        borderTop: '3px solid #C4387A'
      }} data-id="element-176">
            <div className="flex text-brand-title text-sm mb-3" data-id="element-177">⭐⭐⭐⭐⭐</div>
            <h3 className="font-heading font-bold text-brand-title mb-3 text-lg" data-id="element-178">
              "{testimonial.quote}"
            </h3>
            <p className="font-body text-brand-text text-sm mb-4 leading-relaxed italic" data-id="element-179">
              {testimonial.text}
            </p>
            <div className="border-t border-brand-border pt-4" data-id="element-180">
              <p className="font-heading font-semibold text-brand-title text-sm" data-id="element-181">
                — {testimonial.author}
              </p>
              <p className="font-body text-brand-textMuted text-xs" data-id="element-182">
                {testimonial.location}
              </p>
            </div>
          </div>)}
      </div>

      <div className="text-center" data-id="element-183">
        <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-colors w-full md:w-auto tracking-wide shadow-gold-glow" data-id="element-184">
          🚀 QUIERO EL MANUAL AHORA
        </button>
      </div>
    </Section>;
}